export default "__VITE_ASSET__Bo6$Z9_F__"